import { z } from 'zod';
import * as FlatModels from '../../internal';

export const SlideViewerPageQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: FlatModels.PageEntityModels.PageEntityTypeSchema,
});

export type SlideViewerPageQueryResult = z.infer<typeof SlideViewerPageQueryResultSchema>;
